import { __values } from "tslib";
import { StorageEvent } from '../event';
var PluginManager = /** @class */ (function () {
    function PluginManager(storage, eventBus) {
        this.storage = storage;
        this.eventBus = eventBus;
        this.plugins = [];
    }
    PluginManager.prototype.add = function () {
        var e_1, _a;
        var plugins = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            plugins[_i] = arguments[_i];
        }
        try {
            for (var plugins_1 = __values(plugins), plugins_1_1 = plugins_1.next(); !plugins_1_1.done; plugins_1_1 = plugins_1.next()) {
                var plugin = plugins_1_1.value;
                this.plugins.push(plugin);
                plugin.register(this.storage);
                this.eventBus.emit(StorageEvent.RegisterPlugin, plugin);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (plugins_1_1 && !plugins_1_1.done && (_a = plugins_1.return)) _a.call(plugins_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    return PluginManager;
}());
export default PluginManager;
//# sourceMappingURL=plugin-manager.js.map